import React from 'react';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';

export type UnderlinedTab = {
  value: string | number;
  content: string;
};

interface UnderlinedTabsProps {
  tabsContent: UnderlinedTab[];
  selected: UnderlinedTab;
  onSelect: (tab: UnderlinedTab) => void;
  navStyle?: string;
  tabStyle?: string;
  activeStyle?: string;
  inactiveStyle?: string;
  betweenTabsStyle?: string;
}

export const UnderlinedTabs: React.FC<UnderlinedTabsProps> = ({
  tabsContent,
  onSelect,
  selected,
  betweenTabsStyle,
  navStyle = 'w-fit',
  tabStyle = 'px-4 py-1.5 font-bold text-[20px]',
  activeStyle = 'text-primary border-primary border-b-2',
  inactiveStyle = 'text-[#B7C3D5] border-[#E2E7F1] border-b-2 hover:text-primary',
}) => {
  return (
    <div className="w-full">
      <nav className={`flex items-stretch ${navStyle}`} aria-label="Tabs">
        {tabsContent.map((tab, i) => (
          <div
            onClick={() => onSelect(tab)}
            key={tab.value}
            className={`${
              selected.value === tab.value ? activeStyle : inactiveStyle
            } ${tabStyle} ${
              tabsContent.length - 1 !== i && betweenTabsStyle
            } cursor-pointer transition-colors`}
            style={{ WebkitTapHighlightColor: 'transparent' }}
          >
            <ReturnTranslatedText
              text={`general.${tab.content}`}
              origintext={tab.content}
            />
          </div>
        ))}
      </nav>
    </div>
  );
};
